export default __webpack_public_path__ + "img/filter.608e8b7f.svg";